import React from "react";
import { useError } from "../Context/errorContext.js";

class ErrorBoundaryCore extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error) {
    this.props.onError(error);
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}

export default function WithErrorBoundary({ children }) {
  const { setError } = useError();
  return (
    <ErrorBoundaryCore onError={(e) => setError(e.message)}>
      {children}
    </ErrorBoundaryCore>
  );
}
